module.exports = __webpack_public_path__ + "static/media/store.4545a028.webp";